import { render, staticRenderFns } from "./ProvidersTable.vue?vue&type=template&id=03d658bf&scoped=true"
import script from "./ProvidersTable.vue?vue&type=script&lang=js"
export * from "./ProvidersTable.vue?vue&type=script&lang=js"
import style0 from "./ProvidersTable.vue?vue&type=style&index=0&id=03d658bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d658bf",
  null
  
)

export default component.exports